import { Box, Container, Typography } from '@mui/material';
// import AddIcon from '@mui/icons-material/Add';
import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { useParams, useLocation } from 'react-router';
import { casesApi } from 'src/api/casesApi';
// import { Header } from 'src/components/Header';
import CustomizedTable from 'src/components/tables/CustomizedTable';
// import { CustomButton2 } from 'src/components/widgets/buttons/CustomButton2';
import useGenericStyles from 'src/styles/useGenericStyles';
import setTitle from 'src/utils/setTitle';
// import { NameWithAvatar } from 'src/components/tables/renderers/NameWithAvatar';
import { Priority } from 'src/components/tables/renderers/Priority';
// import { Status } from 'src/components/tables/renderers/Status';
import { useSelector } from 'react-redux';
// import { useNavigate } from 'react-router';
// import { Filters } from 'src/components/Filters';
import CasesSubHeader from 'src/components/cases/CasesSubHeader';
import ProjectsSubHeader from 'src/components/organization/projects/ProjectsSubHeader';
import { BillingType } from 'src/components/tables/renderers/BillingType';
import BulkApproveDialog from 'src/components/widgets/Dialog/BulkApproveDialog';
import { useDialog } from 'src/hooks/useDialog';
import { RootState } from 'src/store/store';
import { contactsApi } from 'src/api/contactsApi';
import convertSecondsToTimeString from 'src/utils/convertSecondsToTimeString';
// import { isEmpty, isUndefined } from 'lodash';
import capitalize from 'src/utils/capitalize';
import getProjectTypeShort from 'src/components/organization/projects/projectTypes';
import { Status } from 'src/components/tables/renderers/Status';
import { isEmpty, isUndefined } from 'lodash';

const DEFAULT_VISIBLE_COLUMNS = ["caseKey", "summary", "createdBy", "caseType", "project", "priority", "status"];

function BackLogCases() {
  setTitle('ITSM | Cases');
  const { projectID } = useParams();
  const location = useLocation();
  const isProjectRoute = location.pathname.includes('/projects/');
  // const theme = useTheme();
  // states
  const [caseTypes, setCaseTypes] = useState([]);
  const [internalUsers, setAllInternalUsers] = useState([]);
  const [allData, setAllData] = useState<any>([]);
  const bulkApproveDialog = useDialog();
  const [page, setPage] = useState<any>(0);
  const [pageSize, setPageSize] = useState<any>(25);
  const handlePage = (temp: number) => {
    setPage(temp);
  };
  const [totalCount, setTotalCount] = useState<number>(0);
  const handlePageSize = (temp: number) => {
    setPageSize(temp);
  };
  const [search, setSearch] = useState<any>('');
  const [fetchingData, setFetchingData] = useState(false);
  const [filters, setFilters] = useState<any>({});
  const [sort, setSort] = useState<any>({});
  const handleSearch = (val) => {
    setSearch(val);
  };
  const [selectedRowObjects, setSelectedRowObjects] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [hasAttachments, setHasAttachments] = useState(false);

  const [priorityOptions, setPriorityOptions] = useState([])
  const [statusOptions, setStatusOptions] = useState([])

  // Add this new state for visible columns with default values
  const [visibleColumns, setVisibleColumns] = useState(() => {
    const savedColumns = localStorage.getItem('casesVisibleColumns');
    return savedColumns ? JSON.parse(savedColumns) : DEFAULT_VISIBLE_COLUMNS;
  });

  const [issueTypes, setIssueTypes] = useState([]);
  const [allBillingAccounts, setAllBillingAccounts] = useState([]);
  const [allSprintsByOrganization, setAllSprintsByOrganization] = useState([]);
  const [allExternalUsers, setAllExternalUsers] = useState([]);

  // hooks
  // const navigate = useNavigate();
  const classes = useGenericStyles();
  const allProjects = useSelector(
    (state: RootState) => state.projects.allProjects
  );

  // Get project name for ProjectsSubHeader
  const currentProject = allProjects.find(project => project.id === projectID);

  // Breadcrumb data for ProjectsSubHeader
  const breadcrumbData = {
    links: [
      {
        name: 'Projects',
        to: '/projects',
      },
      {
        name: currentProject?.name,
        to: `/projects/${projectID}`,
        // color: '#4baee8',
      },
    ],
  };

  const getAllTypesAutoComplete = async () => {
    try {
      const response = await casesApi.getCaseTypes();
      if (response.status === 200) {
        setCaseTypes(response.data);
      }
    } catch (error) {
      if (error.message) {
        toast.error(error.message);
      } else {
        toast.error('An error occured while fetching types');
      }
    }
  };

  const getProirityAutoComplete = async () => {
    try {
      const res = await casesApi?.getPriorities();
      setPriorityOptions(res.data);
    } catch (error) {
      if (error.message) {
        toast.error(error.message);
      } else {
        toast.error('An error occured while fetching users');
      }
    }
  };

  const getStatusAutoComplete = async () => {
    try {
      const res = await casesApi?.getStatuses();
      setStatusOptions(res.data);
    } catch (error) {
      if (error.message) {
        toast.error(error.message);
      } else {
        toast.error('An error occured while fetching users');
      }
    }
  };

  const getAllInternalUsersAutoComplete = async () => {
    try {
      const res = await casesApi?.getAutoCompleteUser(true);
      setAllInternalUsers(res.data);
    } catch (error) {
      if (error.message) {
        toast.error(error.message);
      } else {
        toast.error('An error occured while fetching users');
      }
    }
  };

  const getIssueTypesAutoComplete = async () => {
    try {
      const res = await casesApi?.getIssueTypes();
      setIssueTypes(res.data);
    } catch (error) {
      if (error.message) {
        toast.error(error.message);
      } else {
        toast.error('An error occured while fetching issue types');
      }
    }
  };

  const getAllBillingAccounts = async () => {
    try {
      const res = await casesApi?.getAllBillingAccounts();
      setAllBillingAccounts(res.data);
    } catch (error) {
      if (error.message) {
        toast.error(error.message);
      } else {
        toast.error('An error occured while fetching billing accounts');
      }
    }
  };

  const getAllExternalUsers = async () => {
    try {
      const res = await contactsApi.getAll(0, 1000, true, '');
      setAllExternalUsers(res.data?.data);
    } catch (error) {
      if (error.message) {
        toast.error(error.message);
      } else {
        toast.error('An error occured while fetching External Clients');
      }
    }
  };


  function groupBySprintNameToArray(data) {
    const grouped = data.reduce((acc, item) => {
      const { name, id } = item;
      if (!acc[name]) {
        acc[name] = [];
      }
      acc[name].push(id);
      return acc;
    }, {});

    return Object.entries(grouped).map(([name, ids]) => ({
      name,
      id: (ids as any).join(","),
    }));
  }


  const getAllSprintsByOrganization = async () => {
    try {
      const res = await casesApi?.getSprintsByOrganization();

      const formattedSprints = groupBySprintNameToArray(res?.data);

      setAllSprintsByOrganization(formattedSprints);
    } catch (error) {
      if (error.message) {
        toast.error(error.message);
      } else {
        toast.error('An error occured while fetching sprints');
      }
    }
  };

  const handleClearFilters = () => {
    setFilters({});
    setSearch('');
    setHasAttachments(false);
    setStartDate(null);
    setEndDate(null);
  };

  const formatDate = (date) => {
    if (!date) return null;
    const isoString = date.toISOString();
    return isoString.split('T')[0];
  };

  const getAllData = async () => {

    setFetchingData(true);
    try {

      const varr = {
        page,
        pageSize,
        search,
        caseType: filters.Type?.map((itm: any) => itm.value).toString() || null,
        caseKey: filters?.['CASE#']?.map((itm: any) => itm.value).toString() || null,
        summary: filters?.Title?.map((itm: any) => itm.value).toString() || null,
        // priority: filters?.PRIORITY?.map((itm: any) => itm.value).toString() || null,

        priority: filters?.Priority?.map((itm: any) => itm.value).toString() || null,
        // status: filters?.Status?.map((itm: any) => itm.value).toString() || null,
        issueType: filters?.['Issue Type']?.map((itm: any) => itm.value).toString() || null,
        billingAccountType: filters?.Account?.map((itm: any) => itm.value).toString() || null,
        sprint: filters?.Sprint?.map((itm: any) => itm.value).toString() || null,
        approvedBy: filters["Approved By"]?.map((itm: any) => itm.value).toString() || null,


        // caseType: caseType?.map((itm) => itm.id).toString(),
        // priority: priority?.map((itm) => itm.id).toString(),
        // assignee: filters.Reporter?.value || null,
        // status: status?.map((itm) => itm.id).toString(),
        projectId: projectID || filters.Project?.map((itm: any) => itm.value).toString() || null,
        hasAttachments,
        createdBy:
          filters.Reporter?.map((itm: any) => itm.value).toString() || null,
        // isApproved: 0,
        isApproved:
          filters.Approved?.map((itm: any) => itm.value).toString() || null,
        to: formatDate(endDate),
        from: formatDate(startDate),
        // column: columnValue,  // dont remove comment, might need later
        // sort: selectedSort?.value === 'asc' ? '1' : '-1',
        column: sort?.field,
        sort: sort?.order === 'asc' ? '1' : '-1',
        status: '664f4c0c94fda76b3b8ae394'

      };
      console.log('varr', varr)

      const keys = Object.keys(varr);
      const values = Object.values(varr);
      console.log('keys', keys)
      console.log('values', values)
      // Create an array to store the non-empty key-value pairs
      const queryParams = [];
      for (let i = 0; i < values.length; i++) {
        if (values[i] !== '' && values[i] !== null && values[i] !== undefined) {
          // if (keys[i] === 'from' || keys[i] === 'to') {
          //   queryParams.push(`${keys[i]}=${values[i]}`);
          // } else {
          queryParams.push(`${encodeURIComponent(keys[i])}=${values[i]}`);
          // }
        }
      }
      const queryString = queryParams.join('&');
      let response = await casesApi.advanceSearch(queryString);
      if (response?.status === 200) {
        response = response?.data;
        setAllData(response?.data);
        setTotalCount(response?.totalRecords);
        // setFetchingData(false);
      }
      if (response.status === 204) {
        setAllData([]);
        setTotalCount(0);
      }

      setFetchingData(false);
    } catch (error) {
      setFetchingData(false);
      if (error?.response?.status !== 401) {
        toast.error(error?.response?.data?.message);
        setAllData([]);
        setTotalCount(0);
      }
    }
  };

  const customColumns = [
    {
      field: 'caseKey',
      headerName: 'CASE#',
      width: '10%',
      maxWidth: '10%',
      sortable: true,
      filterable: true,
    },
    {
      field: 'summary',
      headerName: 'Title',
      // width: '40%',
      maxWidth: '400px',

      render: (columnValue, data) => (
        <Typography
          title={capitalize(data?.summary)}
          style={{
            fontFamily: 'Inter',
            fontSize: 12,
            fontWeight: 600,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}>
          {capitalize(data?.summary)}
        </Typography>
      ),
      sortable: true,
      filterable: true,
    },
    {
      field: 'createdBy',
      headerName: 'Reporter',
      maxWidth: '10%',
      width: '10%',
      // render: (columnValue, data) => (
      //   <NameWithAvatar name={columnValue?.name ?? ''} rowDataObj={data} />
      // ),
      render: (columnValue) => (
        <Typography
          style={{
            fontFamily: 'Inter',
            fontSize: 12,
            fontWeight: 600,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}>
          {columnValue?.name}
        </Typography>
      ),
      sortable: true,
      filterable: true,
    },
    {
      field: 'caseType',
      headerName: 'Type',
      render: (columnValue) => (
        <Box
          style={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
          title={capitalize(columnValue?.name)}>
          {getProjectTypeShort(columnValue?.name) ?? ''}
        </Box>
      ),
      maxWidth: '8%',
      width: '8%',
      sortable: true,
      filterable: true,
    },
    {
      field: 'timeEstimate',
      headerName: 'Est.',
      maxWidth: '8%',
      width: '8%',
      render: (columnValue) => (
        <Box
          style={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            color:
              capitalize(
                columnValue ? convertSecondsToTimeString(columnValue) : ''
              ) === 'N/A'
                ? 'red'
                : 'initial',
          }}
          title={
            capitalize(convertSecondsToTimeString(columnValue)) === 'N/A'
              ? 'Hours not quoted'
              : capitalize(convertSecondsToTimeString(columnValue))
          }>
          {capitalize(
            columnValue ? convertSecondsToTimeString(columnValue) : ''
          )}
        </Box>
      ),
      sortable: true,
      // filterable: true,
    },
    {
      field: 'project',
      headerName: 'Project',
      render: (columnValue) => (
        <span
          style={{
            fontSize: '12px',
            fontWeight: 700,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}>
          {capitalize(columnValue?.name ?? '')}
        </span>
      ),
      width: '12%',
      maxWidth: '12%',
      sortable: true,
      filterable: true,
    },
    {
      field: 'priority',
      headerName: 'Priority',
      maxWidth: '10%',
      width: '9%',
      render: (columnValue) => (
        <Priority priority={capitalize(columnValue?.name ?? '')} />
      ),
      sortable: true,
      filterable: true,
    },
    {
      field: 'status',
      headerName: 'Status',
      maxWidth: '10%',
      width: '11%',
      render: (columnValue) => (
        <Status status={capitalize(columnValue?.name ?? '')} />
      ),
      sortable: true,
      filterable: true,
    },
    {
      field: 'createdAt',
      headerName: 'Created At',
      maxWidth: '12%',
      width: '12%',
      render: (columnValue) => (
        <Box>{new Date(columnValue).toLocaleString()}</Box>
      ),
      sortable: true,
    },
    {
      field: 'issueType',
      headerName: 'Issue Type',
      maxWidth: '10%',
      width: '10%',
      render: (columnValue) => <Box>{columnValue?.name}</Box>,
      sortable: true,
      filterable: true,
    },
    {
      field: 'expense',
      headerName: 'Expense',
      maxWidth: '8%',
      width: '8%',
      render: (columnValue) =>
        columnValue ? <BillingType value={columnValue} /> : 'N/A',
      sortable: true,
    },
    {
      field: 'billingAccountType',
      headerName: 'Account',
      maxWidth: '12%',
      width: '12%',
      render: (columnValue) => <Box>{columnValue?.name}</Box>,
      sortable: true,
      filterable: true,
    },
    {
      field: 'isApproved',
      headerName: 'Approved',
      maxWidth: '10%',
      width: '10%',
      render: (columnValue, data) => <Box>{!isEmpty(data?.caseType) &&
        !isUndefined(data?.caseType) &&
        data?.caseType?.name === 'Application Feature Request' ? (
        columnValue ? (
          'Approved'
        ) : (
          'Not Approved'
        )
      ) : (
        'Approval Not Required'
      )}</Box>,
      sortable: true,
      filterable: true,
    },
    {
      field: 'approvedBy',
      headerName: 'Approved By',
      maxWidth: '12%',
      width: '12%',
      render: (columnValue) => <Box>{columnValue?.name || 'N/A'}</Box>,
      sortable: true,
      filterable: true,
    },
    {
      field: 'approvedDate',
      headerName: 'Approved Date',
      maxWidth: '12%',
      width: '12%',
      render: (columnValue) => (
        <Box>{columnValue ? new Date(columnValue).toLocaleString() : 'N/A'}</Box>
      ),
      sortable: true,
    },
    {
      field: 'docUrls.figmaLinks',
      headerName: 'Figma Links',
      maxWidth: '20%',
      width: '20%',
      render: (_, data) => (
        <Box style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '4px',
          fontSize: '12px'
        }}>
          {data.docUrls?.figmaLinks?.length > 0 ? (
            data.docUrls.figmaLinks.map((link, index) => (
              <Box
                // eslint-disable-next-line react/no-array-index-key
                key={index}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '4px',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap'
                }}
              >
                <span>•</span>
                <a
                  href={link.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    color: '#2563EB',
                    textDecoration: 'none'
                  }}
                >
                  {link.label || link.url}
                </a>
              </Box>
            ))
          ) : (
            'No links'
          )}
        </Box>
      ),
    },
    {
      field: 'docUrls.googleDocLinks',
      headerName: 'Google Links',
      maxWidth: '20%',
      width: '20%',
      render: (_, data) => (
        <Box style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '4px',
          fontSize: '12px'
        }}>
          {data.docUrls?.googleDocLinks?.length > 0 ? (
            data.docUrls.googleDocLinks.map((link, index) => (
              <Box
                // eslint-disable-next-line react/no-array-index-key
                key={index}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '4px',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap'
                }}
              >
                <span>•</span>
                <a
                  href={link.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    color: '#2563EB',
                    textDecoration: 'none'
                  }}
                >
                  {link.label || link.url}
                </a>
              </Box>
            ))
          ) : (
            'No links'
          )}
        </Box>
      ),
    },
    {
      field: 'sprint',
      headerName: 'Sprint',
      maxWidth: '10%',
      width: '10%',
      render: (columnValue) => <Box>{columnValue?.name}</Box>,
      sortable: true,
      filterable: true,
    },
    {
      field: 'releaseVersion',
      headerName: 'Fix Version',
      maxWidth: '10%',
      width: '10%',
      render: (columnValue) => (
        <Box>{columnValue?.map(v => v?.name || 'N/A').join(', ')}</Box>
      ),
      sortable: true,
      // filterable: true,
    },
  ];

  const getFilterOptions = (column) => {
    switch (column) {
      case 'createdBy':
        return internalUsers.map((userObj) => ({
          label: userObj.name,
          value: userObj.id,
        }));
      case 'caseType':
        return caseTypes.map((typeObj) => ({
          label: typeObj.name,
          value: typeObj.id,
        }));
      case 'project':
        return allProjects.map((projectObj) => ({
          label: projectObj.name,
          value: projectObj.id,
        }));
      case 'caseKey':
        return allData.map((projectObj) => ({
          label: projectObj.caseKey,
          value: projectObj.caseKey,
        }));
      case 'summary':
        return allData.map((projectObj) => ({
          label: projectObj.summary,
          value: projectObj.summary,
        }));
      case 'priority': {
        return priorityOptions.map((priority) => ({
          label: priority?.name,
          value: priority?.id,
        }));
      }
      case 'status': {
        return statusOptions.map((status) => ({
          label: status?.name,
          value: status?.id,
        }));
      }
      case 'issueType': {
        return issueTypes.map((item) => ({
          label: item?.name,
          value: item?.id,
        }));
      }
      case 'billingAccountType': {
        return allBillingAccounts.map((item) => ({
          label: item?.name,
          value: item?.id,
        }));
      }
      case 'sprint': {
        return allSprintsByOrganization.map((item) => ({
          label: item?.name,
          value: item?.id,
        }));
      }
      case 'approvedBy': {
        return allExternalUsers?.map((item) => ({
          label: item?.name,
          value: item?.id,
        }))
      }
      case 'isApproved':
        return [
          {
            label: 'Approved',
            value: "true",
          },
          {
            label: 'Not Approved',
            value: "false",
          },
          {
            label: 'Approval Not Required',
            value: "anr",
          },
        ];
      // Add more cases for other columns
      default:
        return [];
    }
  };

  const handleSort = (field) => {
    setSort((prevSort) => ({
      field,
      order:
        prevSort.field === field && prevSort.order === 'asc' ? 'desc' : 'asc',
    }));
  };

  const handleApplyFilter = (
    currentFilterColumn,
    filterValue,
    filterName,
    checked
  ) => {
    setFilters((prevFilters) => {
      const newFilters = { ...prevFilters };
      if (checked) {
        if (newFilters[currentFilterColumn]) {
          newFilters[currentFilterColumn].push({
            label: filterName,
            value: filterValue,
          });
        } else {
          newFilters[currentFilterColumn] = [
            {
              label: filterName,
              value: filterValue,
            },
          ];
        }
      } else {
        // eslint-disable-next-line no-lonely-if
        if (newFilters[currentFilterColumn]) {
          newFilters[currentFilterColumn] = newFilters[
            currentFilterColumn
          ].filter((obj) => obj.value !== filterValue);

          // If no filters are left for the column, remove the column from filters
          if (newFilters[currentFilterColumn].length === 0) {
            delete newFilters[currentFilterColumn];
          }
        }
      }
      return newFilters;
    });
  };

  const handleRemoveFilter = (column) => {
    setFilters((prevFilters) => {
      const newFilters = { ...prevFilters };
      delete newFilters[column];
      return newFilters;
    });
  };

  const handleSwitchChange = (checked: boolean) => {
    setHasAttachments(checked);
  };

  const handleStartDateChange = (date) => {
    // const formattedDate = formatDate(date);
    setStartDate(date);
    // console.log('Start Date:', formattedDate); // Display the formatted date in console or use it as needed
  };

  const handleEndDateChange = (date) => {
    // const formattedDate = formatDate(date);
    setEndDate(date);
    // console.log('End Date:', formattedDate); // Display the formatted date in console or use it as needed
  };

  const handleClickBulkApprove = (selectedRowsObjsFromTable: any) => {
    bulkApproveDialog.handleOpen();
    const casesWithQuotations: any = selectedRowsObjsFromTable?.filter(
      (item) => parseInt(item?.timeEstimate, 10) > 0
    );
    setSelectedRowObjects(casesWithQuotations);
  };
  useEffect(() => {
    getAllData();
  }, [
    page,
    pageSize,
    JSON.stringify(filters),
    search,
    // JSON.stringify(caseType),
    // JSON.stringify(priority),
    // JSON.stringify(assignee),
    // JSON.stringify(status),
    // JSON.stringify(project),
    hasAttachments,
    // isEscalated,
    // isFirstResponseTimeViolated,
    // isResolveTimeViolated,
    startDate,
    endDate,
    sort
    // date?.from,
    // date?.to,
    // autoRefresh,
    // sortData?.id,
    // sortData?.caseName,
    // sortData?.organization,
    // sortData?.createdBy,
    // sortData?.assignee,
    // sortData?.caseType,
    // sortData?.project,
    // sortData?.resolveTime,
    // sortData?.firstResponseTime,
    // sortData?.priority,
    // sortData?.status,
    // selectedSort?.key,
    // selectedSort?.value,
  ]);

  useEffect(() => {
    // getAllProjectsAutoComplete();
    getStatusAutoComplete()
    getProirityAutoComplete()
    getAllTypesAutoComplete();
    getAllInternalUsersAutoComplete();
    getIssueTypesAutoComplete();
    getAllBillingAccounts();
    getAllSprintsByOrganization();
    getAllExternalUsers();

  }, []);

  const whiteLabel: any = JSON.parse(localStorage.getItem('white_label'));
  if (!whiteLabel?.isApprovalRequired) {
    window.location.href = '/cases/dashboard';
  }

  return (
    <>
      {/* <Header title="All Approvals">
        <CustomButton2
          backgroundColor={theme.palette.primary.main}
          className={classes.button}
          onClick={() => navigate('/cases/add')}>
          <AddIcon
            style={{
              marginRight: '5px',
            }}
          />
          Create case
        </CustomButton2>
      </Header> */}
      <Container maxWidth={false} className={classes.container}>
        {isProjectRoute ? (
          <ProjectsSubHeader
            projectName={currentProject?.name}
            search={search}
            onSearch={handleSearch}
            filters={filters}
            onRemoveFilter={handleRemoveFilter}
            hasAttachments={hasAttachments}
            onSwitchChange={handleSwitchChange}
            startDate={startDate}
            onStartDateChange={handleStartDateChange}
            endDate={endDate}
            onEndDateChange={handleEndDateChange}
            onClearFilters={handleClearFilters}
            breadcrumbData={breadcrumbData}
          />
        ) : (
          <CasesSubHeader
            search={search}
            onSearch={handleSearch}
            filters={filters}
            onRemoveFilter={handleRemoveFilter}
            hasAttachments={hasAttachments}
            onSwitchChange={handleSwitchChange}
            startDate={startDate}
            onStartDateChange={handleStartDateChange}
            endDate={endDate}
            onEndDateChange={handleEndDateChange}
            onClearFilters={handleClearFilters}
          />
        )}
        <CustomizedTable
          heading="All Approvals"
          loading={fetchingData}
          columns={customColumns}
          page={page}
          limit={pageSize}
          handleLimit={handlePageSize}
          handlePage={handlePage}
          data={allData}
          totalRecords={totalCount}
          showCheckBoxes
          // checkBoxClassName={UnApprovedClasses.checkBoxStyle}
          getFilterOptions={getFilterOptions}
          handleSort={handleSort}
          sort={sort}
          handleApplyFilter={handleApplyFilter}
          filters={filters}
          navigateUrl="/cases"
          navigateToKey
          selectRowData
          actionButtonLabel="Bulk Approve"
          actionButtonCallback={handleClickBulkApprove}
          customizableColumns
          defaultVisibleColumns={visibleColumns}
          onColumnChange={(newColumns) => setVisibleColumns(newColumns)}
          storageKey="cases"
        />
        {bulkApproveDialog.open && (
          <BulkApproveDialog
            isOpen={bulkApproveDialog.open}
            handleClose={bulkApproveDialog.handleClose}
            selectedRowsData={selectedRowObjects}
            getAllData={getAllData}
          />
        )}
      </Container>
    </>
  );
}

export default BackLogCases;
